import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const VestuarioRoute = props => {
  const { isVest } = useContext(UserContext);

  if (isVest) {
    return <Route {...props} />;
  } else if (!isVest) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default VestuarioRoute;
